import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/event-categories')({
  staticData: { breadcrumb: 'Категории событий' },
  component: () => <Outlet />,
});
